// ─── Where the writer was, so a discarded tab comes back to the same place ──
// Nicole, 2026-09-09: "anytime this tab isn't the one in full focus it has to
// entirely refresh every single time instead of persisting… when I had it as a
// small box to the side it stopped." That is the browser discarding a HIDDEN
// tab under memory pressure (a visible side window is never discarded) and
// booting the app cold on return. We cannot stop the browser; we can make the
// return instant: remember the tab, channel and conversation in
// sessionStorage — per-tab, survives a discard-reload, never leaks into a
// fresh tab — and restore them on boot when no deep link asked for a place.
const KEY = 'mfml_last_view';
const MAX_AGE_MS = 12 * 60 * 60 * 1000;

export function readLastView() {
  try {
    const j = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (!j || typeof j !== 'object') return null;
    if (Date.now() - (Number(j.ts) || 0) > MAX_AGE_MS) return null;
    return j;
  } catch { return null; }
}

export function saveLastView(patch) {
  try {
    const cur = readLastView() || {};
    sessionStorage.setItem(KEY, JSON.stringify({ ...cur, ...patch, ts: Date.now() }));
  } catch { /* storage unavailable — restore is a convenience */ }
}

// Chrome sets document.wasDiscarded when this load follows a discard.
export function wasDiscarded() {
  try { return !!document.wasDiscarded; } catch { return false; }
}
